import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {AuthService} from "./services/auth.service";
import {PrimeNGConfig} from "primeng/api";
import { TranslateService } from '@ngx-translate/core';
import {DOCUMENT} from "@angular/common";
import {environment} from "../environments/environment";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "./base.component";
import {BasePageComponent} from "./base-page.component";
import {RegistryService} from "./services/domain/registry.service";
import {PreferencesService} from "./services/domain/preferences.service";
import {WorkService} from "./services/domain/work.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [RegistryService]
})
export class AppComponent extends BasePageComponent implements OnInit{
  title = 'sapiens-candidate-frontend';
  private currentTheme = '';

  constructor(private primengConfig : PrimeNGConfig,
              public translateService : TranslateService,
              private http: HttpClient,
              private registryService : RegistryService,
              @Inject(DOCUMENT) private document: Document){
    super();
  }

  ngOnInit(): void {

    this.authService.retrieveAuthDataFromCache();
    this.translateService.setDefaultLang('it');
    this.translate("it");
    this.primengConfig.ripple = true;
    if(environment.theme == 'evo'){
      this.loadTheme("evo");
      //Devo settare il path di base per le immagini
      this.authService.baseImagePath = "evo";
    }else{
      this.authService.baseImagePath = "sapiens";
    }

    if (localStorage.getItem('remeberMe') == "true") {
      if(AuthService.AuthToken != null){
        if(AuthService.AuthToken?.length > 0){

          this.asyncCall(() => this.registryService.getRegistryDetail(), response => {
            if(response.Item != null){
              this.authService.setAuthData(response.Item);
            }
          });
        }
      }
    }else{
      //this.authService.signOut();
    }

    //this.getBlackListChars();

    this.authService.getBlackListChar$.subscribe(response => {
      this.getBlackListChars();
    });
  }

  translate(lang: string) {
    this.translateService.use(lang);
    this.translateService.get('primeng').subscribe(res => this.primengConfig.setTranslation(res));
  }

  @HostListener('window:beforeunload')
  windowBeforeUnload(): void {
    // Prima che si completi il reload della pagina, salva in sessionStorage
    // i dati di autenticazione per non perderli
    this.authService.cacheAuthData();
  }

  private loadTheme(themeName : string){
    const head = this.document.getElementsByTagName('head')[0];
    const themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = `${themeName}-theme.css`;
    }
    else {
      const style = this.document.createElement('link');
      style.id = 'app-theme';
      style.rel = 'stylesheet';
      style.href = `${themeName}-theme.css`;

      head.appendChild(style);
    }

    this.currentTheme = themeName;
  }

  private getBlackListChars(){
    //Recupero i caratteri in blackList
    this.http.get<any>(`${environment.apiUrl}PortalsGenerico/GetCaratteriBlackList`,
      { headers: { 'Content-Type': 'application/json' }}).subscribe(response => {
        //Salvo in Sessione i caratteri in blackList
        sessionStorage.removeItem('blackListChars');
        sessionStorage.setItem('blackListChars', JSON.stringify(response.Items));
      },
      error => {
        console.error('An error occurred:', error);
      });
  }
}
